<template>
    <div class="map" ref="map"></div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';

export default {
	name: "FormGoogleMaps",

	props: {
        center: {
            type: Object,
            required: false,
            default: () => {
                return {
                    lat: -18.145851771694314,
                    lng: -53.7890625
                };
            },
        },
        zoom: {
            type: Number,
            default: 3,
        },
        infoMarker: {
            type: Object,
            required: false,
        },
    },

	data: function() {
		return {
            loading: false,

            google: null,
            map: null,
            marker: null,
            geocoder: null,
            infowindow: null,
            newPosition: null,
		}
	},

    watch: {
        center: function(value) {
            this.center = value;
        },
        zoom: function(value) {
            this.zoom = value;
        },
        infoMarker: async function(value) {
            this.infoMarker = value;
        },
    },

    created: function() {
        // Inicia o mapa
        this.start();
    },

	methods: {
        // Inicia os métodos
        start: async function() {
            // Carrega a API do Google Map
            this.google = await GoogleMapsApiLoader({
                apiKey: this.$api.config.B2B_GOOLE_API_KEY
            });
            
            // Inicia o mapa
            this.initializeMap();

            // Verifica se existem marcadores
            if (this.infoMarker) {
                this.createMarker();
            }
        },

        /**
		 * Gera o mapa
		 **/
        initializeMap: async function() {
            // Cria o mapa
			this.map = new this.google.maps.Map(this.$refs.map, {
				center: {
                    lat: parseFloat(this.center.lat),
                    lng: parseFloat(this.center.lng),
                },
				backgroundColor: "#fefefe",
				zoom: this.zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: this.google.maps.ControlPosition.RIGHT_TOP,
				},
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				styles: [
					/*{
						featureType: "poi",
						stylers: [{
							visibility: "off",
						}],
					},*/{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [{
							visibility: "off",
						}],
					},
				],
			});

            // Cria o geocoder
			this.geocoder = new this.google.maps.Geocoder();
        },

        /**
		 * Adiciona o marcador de endereço
		 **/
        createMarker: function() {
            // Determina o marcador da posiçaõ do APP e coloca no mapa
			let marker = new this.google.maps.Marker({
				map: this.map,
                title: this.infoMarker.title,
                position: {
                    lat: parseFloat(this.infoMarker.position.lat),
                    lng: parseFloat(this.infoMarker.position.lng)
                },
				icon: {
					url: require('@/assets/' + this.infoMarker.icon),
					size: new this.google.maps.Size(40, 40),
					scaledSize: new this.google.maps.Size(40, 40),
					origin: new this.google.maps.Point(0, 0),
					anchor: new this.google.maps.Point(20, 40),
					labelOrigin: new this.google.maps.Point(20, 50),
				},
                draggable: this.infoMarker.draggable,
				zIndex: this.infoMarker.zIndex,
			});
			
			// Define as informações que aparecerão no popup
			let infowindow = new this.google.maps.InfoWindow({
				content: '<div class="capitalized">' + this.infoMarker.infowindow + '</div>',
				pixelOffet: new this.google.maps.Point(0, 0),
			});
			
			// abre o popup ao passar o mouse por cima do marcador
			this.google.maps.event.addListener(marker, "mouseover", function() {
				infowindow.open(this.map, marker);
			});
			
			// Fecha o popup ao retirar o mouse de cima do marcador
			this.google.maps.event.addListener(marker, "mouseout", function() {
				infowindow.close(this.map, marker);
			});
            
            // Verifica se pode arrastar e soltar
            if (this.infoMarker.draggable) {
                // Armazena a nova posição do marcador
                let updateAddressByMarker = this.infoMarker.updateAddressByMarker;
                let updateMarker = this.updateMarker;
                let updateAddress = this.updateAddress;
                this.google.maps.event.addListener(marker, "dragend", async function(event) {
                    let new_content = await updateMarker(marker.getPosition());
                    updateAddress(new_content.address_components, event.latLng.lat(), event.latLng.lng());
                    if (updateAddressByMarker) {
                        infowindow.setContent('<div class="capitalized">' + new_content.formatted_address.replace("State of ", "").replace("Brazil", "Brasil") + '</div>');
                    }
                });
            }

            // Define o centro
            this.map.setCenter(new this.google.maps.LatLng(this.center.lat, this.center.lng));
            this.map.setZoom(this.zoom);

            // Salva o marcador
            this.marker = marker;

            // Salva o popup
            this.infowindow = infowindow;
        },
        
        // Atualiza as informações de endereço do formulário
        updateAddress: function(address_components, lat, lng) {
            if (this.infoMarker.updateAddressByMarker) {
                let street = '';
                let number = '';
                let neighborhood = '';
                let city = '';
                let uf = '';
                let postal_code = '';
                let country = '';

                address_components.forEach(element => {
                    if (element.types.includes("route")) street = element.long_name;
                    if (element.types.includes("street_number")) number = element.long_name;
                    if (element.types.includes("sublocality_level_1")) neighborhood = element.long_name;
                    if (element.types.includes("administrative_area_level_2")) city = element.long_name;
                    if (element.types.includes("administrative_area_level_1")) uf = element.short_name;
                    if (element.types.includes("country")) country = element.long_name;
                    if (element.types.includes("postal_code")) postal_code = element.long_name.replace("-", "");
                });

                this.$emit("updateAddressByMarker", {
                    address: {
                        street: street,
                        number: number,
                        neighborhood: neighborhood,
                        city: city,
                        uf: uf,
                        postal_code: postal_code,
                        country: country,
                    },
                    position: {
                        lat: lat,
                        lng: lng,
                    },
                });
            } else {
                this.$emit("updateAddressByMarker", {
                    position: {
                        lat: lat,
                        lng: lng,
                    },
                });
            }
        },
        
        // Atualiza o popup do marcador
        updateMarker: async function(latLng) {
            let info = null;

            await this.geocoder.geocode({
                latLng: latLng
            }, function(responses) {
                if (responses && responses.length > 0) {
                    info = {
                        address_components: responses[0].address_components,
                        formatted_address: responses[0].formatted_address,
                    };
                } else {
                    info = {
                        address_components: [],
                        formatted_address: 'Não foi possível determinar o endereço dessa localização',
                    };
                }
            });

            return info;
        },
        
        // Atualiza as informações do mapa
        update: function() {
            // Remove o marcador do mapa
            if (this.marker) this.marker.setMap(null);
            
            // Cria novo marcador
            this.$nextTick(() => {
                this.createMarker();
            });
        },
        
        // Limpa e reinicia o mapa
        clear: function() {
            // Remove o marcador do mapa
            if (this.marker) this.marker.setMap(null);
            // Define o centro
            this.map.setCenter(new this.google.maps.LatLng(this.center.lat, this.center.lng));
            //Define o zoom
            this.map.setZoom(this.zoom);
        },
	}
}
</script>

<style scoped>

</style>